import { jsonProperty, Serializable } from 'ts-serializable';

// Ответ на дополнительный вопрос в пройденном опросе (readonly)
export class SurveyResultAnswerModel extends Serializable {
  @jsonProperty(Number, null) answerId: number | null = null;
  @jsonProperty(String, null) descr: string | null = null;
  @jsonProperty(String, null) textValue: string | null = null;
}
